import { FormValues, IFilter } from "../../../types";
import { Button, Col, Container, Label } from "./styles";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { useState } from "react";
import useGetMe from "../../../../../hooks/useCurrentUser";
import { DatePicker, Row } from "antd";
import { Field, Form, Formik } from "formik";
import moment, { Moment } from "moment";
import SingleChargeService from "../../service/singleChargeService";
import { FormValuesSingleCharge } from "../../types";
import { can, PortalPermissions } from "../../../../../config/permissions";


export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters } = props
  const [isLoading] = useState<boolean>(false)
  const user = useGetMe();
  const { MonthPicker } = DatePicker;
  const singleChargeservice = new SingleChargeService();
  const [isLoadingPage, setIsLoading] = useState(false);

  const getInitialValue = (): FormValues => {
    const today = new Date();
    return {
      month: today.getMonth() + 1,
      year: today.getFullYear(),
      merchantId: "",
      serialNumber: "",
      billingType: -1,
    };
  };

  const getBillings = async (submit: any) => {
    const today = new Date();

    const payload = {
      merchantId: submit.merchantId || undefined,
      month: submit.month || (today.getMonth() + 1),
      year: submit.year || today.getFullYear(),
      currentPage: 1,
      pageSize: 20,
      paged: true
    };

    console.log("Payload enviado:", payload);

    getFilters(payload);
    return payload;
  };

  const handleMonthChange = (setFieldValue: (field: string, value: any) => void) =>
    (date: Moment | null) => {
      if (date) {
        setFieldValue('month', date.month() + 1);
        setFieldValue('year', date.year());
      } else {
        setFieldValue('month', null);
        setFieldValue('year', null);
      }
    };

  const handleDownload = async (filter?: FormValuesSingleCharge) => {
    setIsLoading(true);
    const response = await singleChargeservice.downloadSingleChargeXls(filter);

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = "Histórico de Cobranças Avulsa.xlsx"; // Nome do arquivo
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
    setIsLoading(false);
  };


  return (
    <Container style={{ padding: "0 px" }}>
      <LoadingOverlay show={isLoading} relative />

      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik initialValues={getInitialValue()}
        onSubmit={async (values: any) => {
          await getBillings(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <MonthPicker
                style={{ width: "12rem", marginBottom: "0.8rem", height: "32px", marginLeft:"8px" }}
                placeholder={"Selecione o mês e ano"}
                format={"MM/YYYY"}
                value={values.month && values.year ?
                  moment(`${values.year}-${values.month.toString().padStart(2, '0')}-01`) :
                  null}
                onChange={handleMonthChange(setFieldValue)}
                allowClear={true}
              />

              {(user.userType === 3 || user.userType === 6 || user.userType === 7) && (
                <Col>
                  <Field
                    type="text"
                    name="merchantId"
                    placeholder="Cód. Lojista"
                  />
                </Col>
              )}

              <Col>
                <Button
                  htmlType="submit"
                >
                  Consultar
                </Button>
              </Col>

              <Col>
                {can(PortalPermissions.cobrancas.cobrancaPontual.exportar) && (
                  <Button
                    onClick={() => handleDownload(values)}
                    style={{
                      marginBottom: "12px",
                      marginRight: "24px",
                      width: "150px",
                      alignSelf: "start",
                    }}
                  >
                    Download xlsx
                  </Button>
                )}
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  )
}
